import { type FC } from "react";
import { Stack } from "@mui/material";
import { FilterProvider } from "@/partner/shared/components/Filter";
import { StorageFilter } from "./StorageFilter";
import { StorageList } from "./StorageList";
import { StorageSizeUnavailableAlert } from "./StorageSizeUnavailableAlert";
import { StorageTotals } from "./StorageTotals";
import { UsageHistoryChart } from "./UsageHistoryChart";

export type { StorageItem } from "./StorageList";

export const Storage: FC = () => (
  <FilterProvider>
    <Stack spacing={2}>
      <StorageSizeUnavailableAlert />
      <UsageHistoryChart />
      <StorageTotals />
      <StorageFilter />
      <StorageList />
    </Stack>
  </FilterProvider>
);
